import { HeaderAndTableCellDraft } from '@markant-platform/shared/table/model';
import { CartridgeUserDTO, RoleConfig, StaticRole, UserTypeMap } from '@markant-platform/shared/user/model';
import { Filter } from '@markant-platform/shared/ui-filter';
import { UserType } from 'data-model';

export const CARTRIDGE_MEMBER_TABLE_CELLS: HeaderAndTableCellDraft[] = [
  {
    headerCellColumnId: 'salutation',
    headerCellTranslationKey: 'organization.users.salutation.label',
    tableCellContentKey: 'salutation',
    tableCellTranslationPrefix: 'organization.users.salutation',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'firstname',
    headerCellTranslationKey: 'organization.users.firstname',
    tableCellContentKey: 'firstname',
    tableCellContentType: 'CHIP_AND_STRING',
    additionalChip: {
      displayCondition: (user: unknown): boolean => {
        const cartridgeUserDTO = user as CartridgeUserDTO;
        return cartridgeUserDTO.userType === UserType.TECHNICAL;
      },
      tableCellContentKey: 'userType',
      tableCellTranslationPrefix: 'organization.users.type.chip',
      chipConfigMap: UserTypeMap,
    },
  },
  {
    headerCellColumnId: 'lastname',
    headerCellTranslationKey: 'organization.users.lastname',
    tableCellContentKey: 'lastname',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'email',
    headerCellTranslationKey: 'organization.users.email',
    tableCellContentKey: 'email',
    tableCellContentType: 'STRING',
  },
  {
    headerCellColumnId: 'rolesParams',
    headerCellTranslationKey: 'cartridge.members.role',
    tableCellContentKey: 'rolesParams',
    tableCellContentType: 'CHIP_PREDEFINED',
    chipConfigMapStatic: {
      color: 'secondary',
      icon: '',
    },
  },
];

export const ORGANIZATION_FILTER_KEY = 'organization-id';
export const ROLE_FILTER_KEY = 'role';

export const roleConfigOverview: RoleConfig[] = [
  {
    role: StaticRole.PLATFORM_ADMIN,
    routeIdentifier: /^\/backoffice\/cartridges\/[a-z0-9-]{24}\/members/,
    additionalConfig: {
      filterKeys: [ROLE_FILTER_KEY, ORGANIZATION_FILTER_KEY],
    },
  },
  {
    role: StaticRole.PLATFORM_ADMIN,
    routeIdentifier:
      /^\/(backoffice)\/(booked-cartridges|organizations\/[a-z0-9-]+\/services)\/management\/[a-z0-9-]{24}\/[a-z0-9-]{24}\/employees/,
    additionalConfig: {
      filterKeys: [ROLE_FILTER_KEY],
    },
  },
  {
    role: StaticRole.LEISTUNG_ADMIN,
    routeIdentifier: /^\/(backoffice|organization|cartridge-admin)\/variants\/[a-z0-9-]+\/organization\/[a-z0-9-]{24}/,
    additionalConfig: {
      filterKeys: [ROLE_FILTER_KEY],
    },
  },
  {
    role: StaticRole.ORGANIZATION_ADMIN,
    routeIdentifier:
      /^\/(organization|backoffice)\/(booked-cartridges|organization-overview\/services)\/management\/[a-z0-9-]{24}\/[a-z0-9-]{24}\/employees/,
    additionalConfig: {
      filterKeys: [ROLE_FILTER_KEY],
    },
  },
];

export const filterOverview: Filter = {
  [ROLE_FILTER_KEY]: {
    translationKey: 'cartridge.members.role',
    filterOptions: [],
  },
  [ORGANIZATION_FILTER_KEY]: {
    translationKey: 'common.organization',
    filterOptions: [],
  },
};

export const platformAdminCellOverview: HeaderAndTableCellDraft = {
  headerCellColumnId: 'organizationName',
  headerCellTranslationKey: 'common.organization',
  tableCellContentKey: 'organizationName',
  tableCellContentType: 'STRING',
};
